/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Misc Controls
import { NgcErrorModule } from '../controls/error/ngc-error.component';
import { NgcI18NModule } from '../controls/i18n/ngc-i18n.component';
import { NgcIconModule } from '../controls/icon/ngc-icon.component';
import { NgcLinkModule } from '../controls/link/ngc-link.component';

/**
 * NGC Misc Module
 */
@NgModule({
    exports: [
        NgcErrorModule,
        NgcI18NModule,
        NgcIconModule,
        NgcLinkModule
    ]
})
export class NgcMiscModule {
}